import React from "react";
import { Box, Typography } from "@mui/material";
import QRscanner from "./QRscanner";
import FeatureButton from './FeatureButton';
import AppFeatures from '../AppFeatures';

interface QRScannerBoxProps {
  handleQrScan: (text: string) => void;
  decodedToken: any;
  isCameraOpen: boolean;
  cameraText: string;
  toggleCamera: () => void;
  featureValidator: (features:AppFeatures[]) => boolean;
}

const QRScannerBox: React.FC<QRScannerBoxProps> = ({
  handleQrScan,
  decodedToken,
  isCameraOpen,
  cameraText,
  toggleCamera,
  featureValidator
}) => {
  return (
    <>
      {isCameraOpen ? (
        <Box className="qr-scanner-container">
          <Box className="qr-scanner-box">
            <QRscanner onScan={handleQrScan} />
          </Box>
        </Box>
      ) : (
        <FeatureButton
          variant="contained"
          color="primary"
          onClick={toggleCamera}
          features={[AppFeatures.Scan]}
          featureValidator={featureValidator}
        >
          {cameraText}
        </FeatureButton>
      )}      
      {decodedToken === "Wrong QR" && (
        <div className="wrong-qr-container">
          <Typography variant="body1" color="error" className="order-message">
            The QR code scanned is invalid. Please try again with a valid QR code.
          </Typography>
        </div>
      )}
    </>
  );
};

export default QRScannerBox;
